var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrowFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.5,
    r: 18.5,
    transform: "rotate(-180 18.5 18.5)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2586 19.1769L18.9772 23.7711L17.9449 24.8313L11.4162 18.4748L17.7727 11.9461L18.8329 12.9784L14.2388 17.697L25.0315 17.5528L25.0512 19.0326L14.2586 19.1769Z",
    fill: "#8139D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowFilled);
export default __webpack_public_path__ + "static/media/left-Arrow-filled.88092a6673eeaee3ee6d4f143c563529.svg";
export { ForwardRef as ReactComponent };